const purple = {
  100: "#F8F5FF",
  200: "#F2EBFF",
  300: "#E3D2FE",
  400: "#CEAAFD",
  500: "#B376F9",
  600: "#893BCE",
  700: "#7431AF",
  800: "#5F288F",
  900: "#4A1D72",
  contrastDefaultColor: "#ffffff"
}

export default purple
